((w,d,$) => {

  /*****
   * googlemap実行
   */
  $.when(
    $.get('/asset/json/mapstyle.json'),
    w.load.mapScript
  ).done((mapstyle)=>{
    if(w.google == undefined) return false;
    if( $('[data-plugin="googlemap"]').length > 0 ){
      const $map = $('[data-plugin="googlemap"]'),
            styleObj = { name:'mapstyle', style:mapstyle[0]};
      $map.googlemap({styleObj});
    }
  });
  
  $(() => {

    // トップページカスタム
    $.topInit();

    d.querySelector('.p-newsBlock').id = 'contents';

    // ブロック整形
    (function(__){ $.each(__, $.topBlockCustomizer) }({
      'news':{
        button:{
          disp: true,
          text: 'VIEW ALL'
        },
        title:{
          html: '<span>NEWS</span><small>新着情報</small>' // プレーンテキストで動的にする場合は false
        },
        itemlayout: function($this,$catetitle,$date,$new,$title,$catch,$body){
          $this
            .append( $title.append($new) )
            .append( $date.wrapInner('<span class="date-text" />').prepend($catetitle) )
            .append( $catch )
            .append( $body );
          // $date.insertAfter( $catetitle );
        }
      },
      // 'works':{
      //   title:{
      //     html: '<span>WORKS</span><small>施工事例</small>' // プレーンテキストで動的にする場合は false
      //   },
      //   itemlayout: function($this,$catetitle,$date,$new,$title,$catch,$body){
      //     $this
      //       .append( $title.append($new) )
      //       .append( $catetitle )
      //       .append( $date )
      //       .append( $catch )
      //       .append( $body );
      //     // $date.insertAfter( $catetitle );
      //   }
      // },
    }));


    w.load['block-works'].done(()=> {
      $('[data-plugin=getWorksArticle]').each(function(){

        var $this = $(this),
            moduleInfo = {
              content: $this.data('content'),
              module: $this.data('module')
            },
            categories = $.getCategory(moduleInfo),
            articles = $.getArticle(moduleInfo),
            classbase = 'p-worksBlock__',
            post_count = $this.data('postCount');

        // ajax終わったら実行
        $.when(categories,articles).done(function(categories,articles){

          var $list = $this;

          $list.empty();  // 初期化
          // 記事ループ
          $.each(articles,function(i,item){
            if( i >= post_count ) return;
            var cate = categories.filter(v => { if (v.id == item.category) return true }),
                $item =   $('<a />', {class:classbase+'item',href:`/${moduleInfo.content}/?mode=detail&article=${item.id}`}),
                $cont =   $('<figure />', {class:classbase+'image'}).css({'background-image':`url('${item.thumb}')`}),
                $image =  $('<img />', {width:200,height:200,src:item.thumb}),
                $cap =    $('<figcaption />', {class:classbase+'cap'}),
                $category=(cate.length)? $('<a />', {class:'category',href:`/${moduleInfo.content}/?mode=list&cat=${item.category}`}).text(cate[0].name) :false,
                $title =  $('<span />', {class:'title'}).text(item.title),
                $desc =   $('<span />', {class:'desc'}).text(item.desc),
                $capInner = $('<div />',{class:classbase+'cap__inner'});
            $cap
              .append($category)
              .append($title);
              // .append($desc);
            $cont
              .append($image)
              .append($cap.wrapInner($capInner));
            $item.append($cont);
            $item.appendTo($list);
          });
          $list.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            swipeToSlide: true,
            infinite: true,
            variableWidth: true,
            centerMode: true,
            centerPadding: 0,
            autoplay: true,
            autoplaySpeed: 1000,
            speed:2500,
            easing:'easeInOutExpo',
            useCSS:true,
            arrows:false
          })
        });
      });
    })


    /****************************
     * movie background
     */
    const $MV = $('[data-plugin=ytplayer]')
    const param = (id)=> `{
videoURL: '${id}',
containment: '#mainVisual',
mute: true,
showControls: false,
autoPlay: true,
useOnMobile: true,
showYTLogo: false,
abundance: 0,
stopMovieOnBlur: false,
loop: true,
startAt: -3,
anchor: 'center,center'
    }`;
    if( $(w).width() >= 768 )
      $MV.attr('data-property',param('t4n6BLqQzcs'))
    else
      $MV.attr('data-property',param('t4n6BLqQzcs'))

    $MV.YTPlayer()
    $MV.YTPPlay()
    if(!$.UA.is_mobile) $('.mbYTP_wrapper').prependTo('body')

  })

  $.when(w.load.header).done(()=>{

    // グローバルメニューをスクロール量で固定する
    const $logoimg = $('.p-header__logo img').attr('src','/asset/img/svglogo.svg')
    $.scrollspy({
      interval: 150,
      trigger: 10,
      duration: 2500,
      onBefore(){
        $logoimg.attr('src','/asset/img/svglogo.svg')
        $('.p-header').removeClass('is-fixed')
      },
      onAfter(){
        $logoimg.attr('src','/asset/img/colorlogo.png')
        $('.p-header').addClass('is-fixed')
      }
    })

  })
  
  $(w).on('load',() => {
    
    // アンカーリンクスクロール設定
    $('a[href^=#]').off("click")
    $(d).off("click",'a[href^="#"],a[href*="#"]')
    $(d).on('click','a[href^="#"],a[href*="#"]',function(e){
      var path = $(this).attr('href').match(/^([^#]+)(#.*)?/)||[];
      if( path[1] === location.pathname ){
        e.preventDefault();
        $(this).attr('href',path[2]);
      }
      var speed =   500,
          href =    $(this).attr('href'),
          $target = $(href == '#pagetop' || href == '#top' ? 'html' : href ),
          pos =     $target.offset().top;
          var headerHeight = $( ($.UA.is_mobile)? '.ui-header-fixed': '.p-header').height();
          pos = (pos - headerHeight);
      $('body,html').animate({scrollTop:pos},speed,'easeInOutExpo');
      if(href!='#pagetop' && href!='#top' && href!='#contents')
        window.history.pushState(null, null, this.hash);
      return false;
    });

  })

})(window,document,jQuery);